module.exports = __webpack_public_path__ + "img/italy.8bfa3a08.svg";